import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/heatmap';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/visualMap';
import 'echarts/lib/component/transform';

// lag order is 2 of the granger test
const granger_test_p_value = [['Hezuo', 'Hezuo', null], ['Hezuo', 'Lintan', 0.886], ['Hezuo', 'Zhuoni', 0.604], ['Hezuo', 'Maqu', 0.085], ['Hezuo', 'Luqu', 0.824], ['Hezuo', 'Xiahe', 0.127], ['Lintan', 'Hezuo', 0.728], ['Lintan', 'Lintan', null], ['Lintan', 'Zhuoni', 0.710], ['Lintan', 'Maqu', 0.306], ['Lintan', 'Luqu', 0.616], ['Lintan', 'Xiahe', 0.765], ['Zhuoni', 'Hezuo', 0.411], ['Zhuoni', 'Lintan', 0.374], ['Zhuoni', 'Zhuoni', null], ['Zhuoni', 'Maqu', 0.173], ['Zhuoni', 'Luqu', 0.002], ['Zhuoni', 'Xiahe', 0.046], ['Maqu', 'Hezuo', 0.372], ['Maqu', 'Lintan', 0.625], ['Maqu', 'Zhuoni', 0.394], ['Maqu', 'Maqu', null], ['Maqu', 'Luqu', 0.425], ['Maqu', 'Xiahe', 0.640], ['Luqu', 'Hezuo', 0.601], ['Luqu', 'Lintan', 0.801], ['Luqu', 'Zhuoni', 0.794], ['Luqu', 'Maqu', 0.252], ['Luqu', 'Luqu', null], ['Luqu', 'Xiahe', 0.030], ['Xiahe', 'Hezuo', 0.361], ['Xiahe', 'Lintan', 0.587], ['Xiahe', 'Zhuoni', 0.287], ['Xiahe', 'Maqu', 0.062], ['Xiahe', 'Luqu', 0.873], ['Xiahe', 'Xiahe', null]];

class GrangerHeatmapChart extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme, 'EN');
    this.myChart = echarts.init(document.getElementById('granger-heatmap-chart'), 'customColorTheme');
    var option = {
      animation: true,
      grid: {
        left: 'center',
        width: '80%',
        top: '5%',
        height: '86%',
      },
      tooltip: {
        formatter: (params) => {
          return `${params.seriesName}<br/>${params.marker} ${params.value[1]}→${params.value[0]}&emsp;&ensp;<b>${params.value[2]}</b>`
        }
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        position: 'top',
        type: 'category',
        inverse: false,
        nameTextStyle: {
          width: '5px',
          overflow: 'breakAll'
        },
        axisLabel: {
          interval: 0
        }
      },
      yAxis: {
        type: 'category',
        inverse: true,
      },
      visualMap: {
        type: 'piecewise',
        pieces: [
          { min: 0, max: 0.001, label: '0 - 0.001' },
          { min: 0.001, max: 0.01, label: '0.001 - 0.01' },
          { min: 0.01, max: 0.05, label: '0.01 - 0.05' },
          { min: 0.05, max: 0.1, label: '0.05 - 0.1' },
          { min: 0.1, label: '> 0.1' }
        ],
        calculable: true,
        orient: 'horizontal',
        top: 'bottom',
        left: 'center',
        inRange: {
          color: ['#7952b3', '#997cc5', '#baa6d8', '#dbd1eb', '#f4f1f9']
        }
      },
      series: {
        name: 'p-value',
        type: 'heatmap',
        data: granger_test_p_value,
        label: {
          show: true,
          fontSize: 14,
          fontWeight: 400,
        }
      }
    };
    this.myChart.setOption(option);
  }

  componentDidUpdate() {
    this.myChart.resize();
  }

  render() {
    return (
      <>
        <div class="m-auto" id="granger-heatmap-chart" style={{ height: '500px' }}></div>
      </>
    );
  }
}

export default GrangerHeatmapChart;